import styled from 'styled-components';

export const StagesSectionStyled = styled.section`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 15rem;
`;
